import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { ToastContainer, toast } from "react-toastify";
import {
  clockIcon,
  testSheet,
  WhoWeAreImgpowerd,
  CognizantColor,
  testScore,
  userTestImage,
  resetAns,
  maxScore,
  mobileViewQs,
} from "../../Common/CommonImages";
import {
  handleBackButton,
  handleBeforeUnload,
} from "../../Common/EventHandlers";
import {
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  Tab,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  ButtonGroup,
  Stack,
  capitalize,
  LinearProgress,
  Modal,
  Tooltip,
  Divider,
} from "@mui/material";
import {
  BASE_URL,
  handleDynamicRequestHeader,
} from "../../Common/CommonExport";
import { submitProgrammingAnswer } from "../../services/assessment.api";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Webcam from "react-webcam";
import {
  setAnswer,
  setValue,
  setQuestionIndex,
  recordQuestionCheating,
  resetAllAnswers,
} from "../../store/Test/action";

import {
  setCandidateFullExit,
  setCandidateTabSwitch,
  resetCandidateCounts,
} from "../../store/Candidate/action";
import {
  setWebcamStream,
  setCameraStatus,
  setIsCameraRequired,
  takeSnapshot,
  startCamera,
} from "../../store/Camera/action";
import { takeScreenSnapshot, askScreenShare } from "../../store/Screen/actions";

import ProgrammingTypeQuestion from "../../Components/Programming/ProgrammingTypeQuestion";
import TypingAnalyzer from "../../utils/programming/typingAnalyzer";
import SubmissionReminderModal from "../../Components/Programming/SubmissionReminderModal";
import { handleSubmit } from "../../utils/Utils.SubmitTest";

const base64 = require("base64-js");

const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: "user",
};

function Overview() {
  const testName = useSelector((state) => state.testReducer.name);
  const company = useSelector((state) => state.testReducer.company);
  const totalScore = useSelector((state) => state.testReducer.score);
  const totalQue = useSelector((state) => state.testReducer.questions);
  const value = useSelector((state) => state.testReducer.value);
  const assessmentId = useSelector((state) => state.testReducer.testId);
  const remainingTime = useSelector((state) => state.testReducer.newTime);
  const questionIndex = useSelector((state) => state.testReducer.index);
  const screen = useSelector((state) => state.testReducer.screen);
  const selectedAnswers = useSelector(
    (state) => state.testReducer.selectedAnswers,
  );

  const settings = useSelector((state) => state.testReducer.setting);

  const inviteId = useSelector((state) => state.candidateReducer.id);
  const fullScreenExitCount = useSelector(
    (state) => state.candidateReducer.count || 0,
  );
  const prevExitCountRef = useRef(fullScreenExitCount);

  const candidate_total_time_spent = useSelector(
    (state) => state.candidateReducer.time,
  );

  const testData = useSelector((state) => state.testReducer.data);

  const [showQuestions, setShowQuestions] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  const initialTabCount = useSelector(
    (state) => state.candidateReducer.tab || 0,
  );
  const [tabSwitchCount, setTabSwitchCount] = useState(initialTabCount);
  const [questionBaseTabSwitch, setQuestionBaseTabSwitch] =
    useState(initialTabCount);
  const [questionBaseFullScreenExit, setQuestionBaseFullScreenExit] =
    useState(fullScreenExitCount);
  const questionsRef = useRef([]);
  const typingAnalyzerRef = useRef(null);
  const snapshotTimerRef = useRef(null);
  const tabAwaySnapshotsRef = useRef({ webCam: null, screen: null });

  const webcamRef = useRef(null);

  const reduxWebcamStream = useSelector(
    (state) => state.cameraReducer.webcamStream,
  );
  const screenStream = useSelector((state) => state.screenReducer.screenStream);
  const [isProgrammingAttemptsExhausted, setIsProgrammingAttemptsExhausted] =
    useState(false);
  const [showSubmissionReminder, setShowSubmissionReminder] = useState(false);
  const pendingNavigationActionRef = useRef(null);
  const programmingQuestionRef = useRef(null);

  // Webcam Draggable State for Mobile/Small Screens
  const [webcamPos, setWebcamPos] = useState({ x: 0, y: 0 });
  const [isDraggingWebcam, setIsDraggingWebcam] = useState(false);
  const webcamDragRef = useRef({ startX: 0, startY: 0 });

  const handleWebcamPointerDown = (e) => {
    if (window.innerWidth >= 1024) return; // Prevent dragging on large desktop
    setIsDraggingWebcam(true);
    webcamDragRef.current.startX = e.clientX - webcamPos.x;
    webcamDragRef.current.startY = e.clientY - webcamPos.y;
    e.target.setPointerCapture(e.pointerId);
  };

  const handleWebcamPointerMove = (e) => {
    if (!isDraggingWebcam) return;
    setWebcamPos({
      x: e.clientX - webcamDragRef.current.startX,
      y: e.clientY - webcamDragRef.current.startY,
    });
  };

  const handleWebcamPointerUp = (e) => {
    setIsDraggingWebcam(false);
    e.target.releasePointerCapture(e.pointerId);
  };

  // Recheck Modal State
  // const [showRecheckModal, setShowRecheckModal] = useState(false); // REMOVED - using App.js modal now

  const showWebcam = settings?.some(
    (s) =>
      (s.setting === "Take Snapshots via webcam every 30 second" ||
        s.setting === "Take Snapshots via webcam every 30 seconds") &&
      s.active,
  );

  const cameraStarted = useSelector((state) => state.cameraReducer.isCameraOn);

  // Monitor streams and settings removed - moved to App.js for unified modal handling
  // useEffect(() => ... )

  useEffect(() => {
    typingAnalyzerRef.current = new TypingAnalyzer({
      enableVerboseLogging: false,
      analysisInterval: 2000,
    });
    typingAnalyzerRef.current.startTracking();
    return () => {
      if (typingAnalyzerRef.current) typingAnalyzerRef.current.stopTracking();
    };
  }, []);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleUserMedia = useCallback(
    (stream) => {
      // Update global store with the new stream from Webcam component
      dispatch(setWebcamStream(stream));
      dispatch(setCameraStatus(true));
      dispatch(setIsCameraRequired(true));
    },
    [dispatch],
  );

  const handleReview = () => {
    dispatch(setCandidateTabSwitch(tabSwitchCount));
    navigate("/review");
  };

  const handleResetTest = () => {
    if (
      !window.confirm(
        "Are you sure you want to reset this test? This will clear all your answers and progress. You can start fresh with new attempts.",
      )
    ) {
      return;
    }

    try {
      toast.info("Resetting test...", { autoClose: 1000 });

      // Reset all Redux state
      dispatch(resetAllAnswers());
      dispatch(resetCandidateCounts());

      // Reset local state
      setTabSwitchCount(0);
      setCurrentQuestionIndex(0);

      // Scroll to top
      scrollToTop();

      toast.success("Test reset successfully! You can now start fresh.", {
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error resetting test:", error);
      toast.error("An error occurred while resetting the test.");
    }
  };

  const [timeSpent, setTimeSpent] = useState(0);

  const timerRef = useRef(null);

  // Sync initialTabCount from Redux if it updates after mount
  useEffect(() => {
    if (initialTabCount > tabSwitchCount) {
      setTabSwitchCount(initialTabCount);
    }
  }, [initialTabCount]);

  useEffect(() => {
    // Push the current state into the history stack
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", handleBackButton);
    window.addEventListener("beforeunload", handleBeforeUnload);
  }, []);

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs < 10 ? "0" + hrs : hrs}:${mins < 10 ? "0" + mins : mins}:${
      secs < 10 ? "0" + secs : secs
    }`;
  };

  const handleChange = (event, newValue) => {
    setCurrentQuestionIndex(0);
    dispatch(setValue(newValue));
    dispatch(setQuestionIndex(0));
  };

  const scrollToTop = () => {
    const questionRightDiv = document.querySelector(".question-right");
    if (questionRightDiv) {
      questionRightDiv.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      setCurrentQuestionIndex(0);
    }
  };

  const handleChangeNew = (event, newValue, index) => {
    dispatch(setValue(newValue));
    setCurrentQuestionIndex(index);
    dispatch(setQuestionIndex(index));
  };

  const checkboxStyle = {
    width: "40px",
    height: "40px",
  };

  const handleMobile = () => {
    setShowQuestions((prevState) => !prevState);
  };

  useEffect(() => {
    setTimeSpent(0);
    // Reset TypingAnalyzer for the new question to clear flags/events from previous questions
    typingAnalyzerRef.current?.reset();

    // Start a fresh timer for the current question
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setTimeSpent((prev) => prev + 1);
    }, 1000);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [currentQuestionIndex, value]);

  // Update question-level baselines when moving to a new question
  useEffect(() => {
    setQuestionBaseTabSwitch(tabSwitchCount);
    setQuestionBaseFullScreenExit(fullScreenExitCount);
  }, [currentQuestionIndex, value]);

  // Periodic webcam snapshots (every 30 seconds)
  useEffect(() => {
    if (!showWebcam || !reduxWebcamStream) return;

    console.log("📸 Starting periodic webcam snapshot timer (30s)");
    const interval = setInterval(() => {
      dispatch(takeSnapshot(reduxWebcamStream, assessmentId, inviteId));
    }, 30000);
    snapshotTimerRef.current = interval;

    return () => {
      clearInterval(interval);
      snapshotTimerRef.current = null;
    };
  }, [showWebcam, reduxWebcamStream, dispatch, assessmentId, inviteId]);

  const submitAnswer = async (
    questionId,
    newValue,
    skillId,
    questionType,
    difficultyLevel,
    programmingData = null,
  ) => {
    const finalTimeSpent =
      newValue.timeSpent !== undefined ? newValue.timeSpent : timeSpent;

    handleAnswerSelection(
      questionId,
      newValue.selectedAnswer,
      newValue.isAnswered,
      newValue.isReviewed,
      finalTimeSpent,
      newValue.retakes || 0,
    );
    dispatch(setCandidateTabSwitch(tabSwitchCount));

    // Calculate global system cheating flags
    // Determine final cheating data
    let finalDetectedCheatings = [];

    // Include flags passed directly in newValue (for immediate MCQ reporting)
    if (
      newValue.detectedCheatings &&
      Array.isArray(newValue.detectedCheatings)
    ) {
      finalDetectedCheatings = [
        ...finalDetectedCheatings,
        ...newValue.detectedCheatings,
      ];
    }

    // Merge cheatings stored in Redux for this question
    const storedQuestionData = selectedAnswers[questionId];
    if (
      storedQuestionData &&
      Array.isArray(storedQuestionData.detectedCheatings)
    ) {
      finalDetectedCheatings = [
        ...finalDetectedCheatings,
        ...storedQuestionData.detectedCheatings,
      ];
    }

    if (programmingData) {
      // For programming, merge editor events with previously collected events
      finalDetectedCheatings = [
        ...finalDetectedCheatings,
        ...(programmingData.detectedCheatings || []),
      ];
    }

    // Merge global TypingAnalyzer flags (for Copy/Paste detection in MCQ/SQL)
    if (
      typingAnalyzerRef.current &&
      typeof typingAnalyzerRef.current.getSuspiciousEvents === "function"
    ) {
      const globalFlags = typingAnalyzerRef.current.getSuspiciousEvents();
      if (globalFlags && globalFlags.length > 0) {
        finalDetectedCheatings = [...finalDetectedCheatings, ...globalFlags];
      }
    }

    // Deduplicate just in case
    finalDetectedCheatings = [...new Set(finalDetectedCheatings)];
    let finalIsCheatingDetected = finalDetectedCheatings.length > 0;

    // Consolidate Snapshots from newValue and stored Redux state
    let finalWebCamSnapShots = newValue.webCamSnapShots || [];
    let finalScreenSnapShots = newValue.screenSnapShots || [];

    if (storedQuestionData) {
      if (storedQuestionData.webCamSnapShots) {
        finalWebCamSnapShots = [
          ...finalWebCamSnapShots,
          ...storedQuestionData.webCamSnapShots,
        ];
      }
      if (storedQuestionData.screenSnapShots) {
        finalScreenSnapShots = [
          ...finalScreenSnapShots,
          ...storedQuestionData.screenSnapShots,
        ];
      }
    }
    finalWebCamSnapShots = [...new Set(finalWebCamSnapShots)];
    finalScreenSnapShots = [...new Set(finalScreenSnapShots)];

    const requestBody = {
      skillId: skillId,
      questionType: questionType,
      difficultyLevel: difficultyLevel,
      questionId: questionId,
      selectedAnswer: newValue.selectedAnswer
        ? Array.isArray(newValue.selectedAnswer)
          ? newValue.selectedAnswer
          : [newValue.selectedAnswer]
        : [],
      timeSpent: finalTimeSpent,
      totalTimeSpent: candidate_total_time_spent,
      fullScreenExitCount: fullScreenExitCount, // Global count for the entire assessment
      tabSwitchCount: tabSwitchCount, // Global count for the entire assessment
      questionFullScreenExitCount: Math.max(
        0,
        fullScreenExitCount - questionBaseFullScreenExit,
      ), // Question-specific count
      questionTabSwitchCount: Math.max(
        0,
        tabSwitchCount - questionBaseTabSwitch,
      ), // Question-specific count
      retakes: newValue.retakes || 0,
      webCamSnapShots: finalWebCamSnapShots,
      screenSnapShots: finalScreenSnapShots,
      missingCandidateSnapShotIds: newValue.missingCandidateSnapShotIds,
      duplicateCandidateSnapShotIds: newValue.duplicateCandidateSnapShotIds,
      multipleCandidateSnapShotIds: newValue.multipleCandidateSnapShotIds,
      ...programmingData,
      // Explicitly set these AFTER spread to ensure merged data is used
      isCheatingDetected: finalIsCheatingDetected,
      detectedCheatings: finalDetectedCheatings,
    };

    const method = "PATCH";
    const url = `${BASE_URL}/public/assessment/${inviteId}/update-candidate-result`;
    setTimeSpent(0);
    const wrongResponse = () => {
      console.log("Failed to submit answer");
    };
    const rightResponse = (data) => {};

    if (questionType === "programmingQuestions" && programmingData) {
      submitProgrammingAnswer(assessmentId, {
        candidateAssessmentId: inviteId,
        questionId: questionId,
        type: "programming",
        sourceCode: programmingData.code,
        candidateAnswer: programmingData.code,
        programmingLanguageId: programmingData.programmingLanguageId,
        skill: programmingData.skillName,
        timeSpent: finalTimeSpent,
        retakes: newValue.retakes || 0,
        isCheatingDetected: finalIsCheatingDetected,
        detectedCheatings: finalDetectedCheatings,
        tabSwitches: Math.max(0, tabSwitchCount - questionBaseTabSwitch), // Question-specific
        fullScreenExitCount: Math.max(
          0,
          fullScreenExitCount - questionBaseFullScreenExit,
        ), // Question-specific
        webCamSnapShots: finalWebCamSnapShots,
        screenSnapShots: finalScreenSnapShots,
        missingCandidateSnapShotIds: newValue.missingCandidateSnapShotIds,
        duplicateCandidateSnapShotIds: newValue.duplicateCandidateSnapShotIds,
        multipleCandidateSnapShotIds: newValue.multipleCandidateSnapShotIds,
      })
        .then(() => rightResponse())
        .catch((err) => {
          console.error("Programming submission failed", err);
          wrongResponse();
        });
    } else {
      handleDynamicRequestHeader(
        method,
        url,
        requestBody,
        null,
        wrongResponse,
        rightResponse,
      );
    }
  };

  const questionTypes = [
    "mcqQuestions",
    "programmingQuestions",
    "sqlQuestions",
  ];
  const difficulties = ["easy", "medium", "hard"];

  const totalQuestions = testData?.reduce((total, test) => {
    questionTypes.forEach((questionType) => {
      if (questionType in test) {
        difficulties.forEach((difficulty) => {
          // Use ?? 0 to guard against undefined when the difficulty sub-array
          // key is absent (e.g. sqlQuestions only has `isRandom`, no easyQuestions etc.)
          // Without this, `total += undefined` poisons the accumulator with NaN.
          total += test[questionType][`${difficulty}Questions`]?.length ?? 0;
        });
      }
    });
    return total;
  }, 0);
  const scrollToQuestion = (questionIndex) => {
    const questionRef = questionsRef.current[questionIndex];
    const questionRightDiv = document.querySelector(".question-right");

    if (questionRef && questionRightDiv) {
      const containerRect = questionRightDiv.getBoundingClientRect();
      const elementRect = questionRef.getBoundingClientRect();
      const scrollTop = questionRightDiv.scrollTop;
      const elementTop = elementRect.top - containerRect.top + scrollTop;

      questionRightDiv.scrollTo({
        top: elementTop - 20,
        behavior: "smooth",
      });
    }
  };

  let overallQuestionIndex = 0;
  let overallQuestionIndexNew = 0;

  const handleAnswerSelection = (
    questionId,
    selectedAnswer,
    isAnswered,
    isReviewed,
    timeSpent,
    retakes,
  ) => {
    dispatch(
      setAnswer(
        questionId,
        selectedAnswer,
        isAnswered,
        isReviewed,
        timeSpent,
        retakes,
      ),
    );
  };

  const currentSkillQuestions = useMemo(() => {
    if (!testData || !testData[value - 2]) return [];
    const skill = testData[value - 2];
    let questions = [];
    questionTypes.forEach((type) => {
      if (type in skill) {
        difficulties.forEach((diff) => {
          const qs =
            skill[type][`${diff}Questions`]?.map((q) => ({
              ...q,
              questionType: type,
              difficulty: diff,
              skillName:
                skill.skill?.skillName || skill.skill?.name || "Programming",
            })) || [];
          questions = [...questions, ...qs];
        });
      }
    });
    return questions;
  }, [testData, value, difficulties, questionTypes]);

  useEffect(() => {
    setIsProgrammingAttemptsExhausted(false);
  }, [currentQuestionIndex, value]);

  const handleNavigationAttempt = (actionCallback) => {
    const currentQuestion = currentSkillQuestions[currentQuestionIndex];
    const isProgramming =
      currentQuestion?.questionType === "programmingQuestions";
    const isAnswered = selectedAnswers[currentQuestion?._id]?.isAnswered;

    if (isProgramming && !isAnswered) {
      pendingNavigationActionRef.current = actionCallback;
      setShowSubmissionReminder(true);
    } else {
      actionCallback();
    }
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      // TAB AWAY or TAB BACK
      const isTabBack = !document.hidden;

      if (isTabBack) {
        // Update tab switch count
        setTabSwitchCount((prevCount) => prevCount + 1);

        // [Feature] Auto-submit and logout if "Logout on leaving a test interface" is active
        const logoutOnLeaveSetting = settings?.find(
          (s) => s.setting === "Logout on leaving a test interface" && s.active,
        );

        if (logoutOnLeaveSetting) {
          toast.error("You left the test interface. Submitting test...", {
            autoClose: 2000,
          });

          // Exit fullscreen before redirecting to feedback
          const exitFullScreenPromise = async () => {
            try {
              if (document.fullscreenElement) {
                await document.exitFullscreen();
              }
            } catch (err) {
              console.warn("Failed to exit fullscreen:", err);
            }
          };

          handleSubmit()
            .then(async () => {
              // Exit fullscreen and redirect to feedback page
              await exitFullScreenPromise();

              // Remove event listeners to prevent dialogs
              window.removeEventListener("beforeunload", () => {});
              window.removeEventListener("popstate", () => {});
              window.onbeforeunload = null;

              // Redirect to feedback page
              navigate("/feedback");
            })
            .catch(async (err) => {
              console.error("Auto submit failed", err);
              await exitFullScreenPromise();
              navigate("/feedback"); // Still go to feedback even if submit fails
            });
          return;
        }

        // Handle Redux dispatch and answer submission in next tick
        setTimeout(async () => {
          const currentQuestion = currentSkillQuestions[currentQuestionIndex];
          const currentSkill = testData?.[value - 2]?.skill;

          // Retrieve Evidence (Snapshots) captured when the user tabbed away
          const snapshotIds = {
            webCamSnapShots: [],
            screenSnapShots: [],
          };

          if (tabAwaySnapshotsRef.current.webCam) {
            try {
              const fileId = await tabAwaySnapshotsRef.current.webCam;
              if (fileId) snapshotIds.webCamSnapShots.push(fileId);
            } catch (e) {
              console.error("Webcam snapshot retrieval failed", e);
            }
            tabAwaySnapshotsRef.current.webCam = null;
          }

          if (tabAwaySnapshotsRef.current.screen) {
            try {
              const fileIds = await tabAwaySnapshotsRef.current.screen;
              if (fileIds) {
                if (Array.isArray(fileIds)) {
                  snapshotIds.screenSnapShots.push(...fileIds.filter(Boolean));
                } else {
                  snapshotIds.screenSnapShots.push(fileIds);
                }
              }
            } catch (e) {
              console.error("Screen snapshot retrieval failed", e);
            }
            tabAwaySnapshotsRef.current.screen = null;
          }

          // Only proceed with question-specific logic if a current question/skill is defined
          if (currentQuestion && currentSkill) {
            const isProgramming =
              currentQuestion.questionType === "programmingQuestions" ||
              currentQuestion.questionType === "programming";

            if (!isProgramming) {
              // MCQ: Report immediately on Tab Back
              const existingAnswer = selectedAnswers[currentQuestion._id] || {};
              const cheatingPayload = {
                ...existingAnswer,
                detectedCheatings: [`Tab switch detected`],
                ...snapshotIds, // Attach snapshot IDs from when user left
              };
              submitAnswer(
                currentQuestion._id,
                cheatingPayload,
                currentSkill._id,
                currentQuestion.questionType,
                currentQuestion.difficulty,
              );
            } else {
              // Programming: Just record in Redux
              dispatch(
                recordQuestionCheating(
                  currentQuestion._id,
                  `Tab switch back detected`,
                  snapshotIds,
                ),
              );
              // Programming questions need a way to store these snapshot IDs in Redux too
              // For now, we are focusing on immediate submission for MCQ or global flagging
              // If we want to attach these to the *next* submission of programming, we might need a Redux action for storing evidence
            }
          }
        }, 0);
      } else {
        // TAB AWAY - Capture immediately when user leaves
        console.log("🚫 User switched away - capturing evidence...");

        // Trigger captures immediately and store promises to retrieve on return
        if (reduxWebcamStream) {
          tabAwaySnapshotsRef.current.webCam = dispatch(
            takeSnapshot(reduxWebcamStream, assessmentId, inviteId),
          );
        }
        if (screenStream) {
          tabAwaySnapshotsRef.current.screen = new Promise((resolve) => {
            // Take one screenshot immediately to catch the task switcher/initial departure
            const immediatePromise = dispatch(
              takeScreenSnapshot(screenStream, assessmentId, inviteId),
            ).catch(() => null);

            // Wait 1.5 seconds, then take another in case they landed on a different app
            setTimeout(async () => {
              try {
                const delayedFileId = await dispatch(
                  takeScreenSnapshot(screenStream, assessmentId, inviteId),
                );
                const immediateFileId = await immediatePromise;
                // Return whichever one we got, or both
                resolve([immediateFileId, delayedFileId].filter((id) => id));
              } catch (e) {
                console.error("Delayed screen snapshot failed:", e);
                const immediateFileId = await immediatePromise;
                resolve(immediateFileId ? [immediateFileId] : null);
              }
            }, 1000); // 1-second delay to capture the destination screen after Alt+Tab
          });
        }

        const currentQuestion = currentSkillQuestions[currentQuestionIndex];
        const currentSkill = testData?.[value - 2]?.skill;

        if (currentQuestion && currentSkill) {
          // Also record cheating flag immediately
          dispatch(
            recordQuestionCheating(
              currentQuestion._id,
              "Tab switched away",
              {},
            ),
          );
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [
    dispatch,
    currentQuestionIndex,
    currentSkillQuestions,
    selectedAnswers,
    value,
    testData,
    reduxWebcamStream,
    screenStream,
    assessmentId,
    inviteId,
    settings,
  ]);

  // Sync local tab switch count to Redux
  useEffect(() => {
    if (tabSwitchCount > 0) {
      dispatch(setCandidateTabSwitch(tabSwitchCount));
    }
  }, [tabSwitchCount, dispatch]);

  // Handle Fullscreen exit globally by monitoring the global exit count
  useEffect(() => {
    if (fullScreenExitCount > prevExitCountRef.current) {
      const currentQuestion = currentSkillQuestions[currentQuestionIndex];
      const currentSkill = testData?.[value - 2]?.skill;

      (async () => {
        const snapshotIds = {
          webCamSnapShots: [],
          screenSnapShots: [],
        };

        if (reduxWebcamStream) {
          try {
            const fileId = await dispatch(
              takeSnapshot(reduxWebcamStream, assessmentId, inviteId),
            );
            if (fileId) snapshotIds.webCamSnapShots.push(fileId);
          } catch (e) {
            console.error("Webcam snapshot failed", e);
          }
        }

        if (screenStream) {
          try {
            const fileId = await dispatch(
              takeScreenSnapshot(screenStream, assessmentId, inviteId),
            );
            if (fileId) snapshotIds.screenSnapShots.push(fileId);
          } catch (e) {
            console.error("Screen snapshot failed", e);
          }
        }

        const currentQuestion = currentSkillQuestions[currentQuestionIndex];
        const currentSkill = testData?.[value - 2]?.skill;

        if (currentQuestion && currentSkill) {
          const isProgramming =
            currentQuestion.questionType === "programmingQuestions" ||
            currentQuestion.questionType === "programming";

          if (!isProgramming) {
            console.log(
              "🚫 Fullscreen exit detected for MCQ - triggering update",
            );
            const existingAnswer = selectedAnswers[currentQuestion._id] || {};
            const cheatingPayload = {
              ...existingAnswer,
              detectedCheatings: ["Fullscreen exit detected"],
              ...snapshotIds,
            };
            submitAnswer(
              currentQuestion._id,
              cheatingPayload,
              currentSkill._id,
              currentQuestion.questionType,
              currentQuestion.difficulty,
            );
          } else {
            // Record in Redux for programming question
            dispatch(
              recordQuestionCheating(
                currentQuestion._id,
                "Fullscreen exit detected",
                snapshotIds,
              ),
            );
          }
        }
      })();
    }
    prevExitCountRef.current = fullScreenExitCount;
  }, [
    fullScreenExitCount,
    currentQuestionIndex,
    currentSkillQuestions,
    selectedAnswers,
    value,
    testData,
    dispatch,
    reduxWebcamStream,
    screenStream,
    assessmentId,
    inviteId,
  ]);

  const handlePrevQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
      dispatch(setQuestionIndex(currentQuestionIndex - 1));
    } else if (parseInt(value) > 2) {
      const prevSkill = testData[parseInt(value) - 3];
      const prevCount = getSkillQuestionCount(prevSkill);
      dispatch(setValue((parseInt(value) - 1).toString()));
      setCurrentQuestionIndex(prevCount - 1);
      dispatch(setQuestionIndex(prevCount - 1));
    } else if (parseInt(value) === 2) {
      dispatch(setValue("1"));
    }
  };

  const handleNextQuestion = () => {
    if (currentQuestionIndex < currentSkillQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      dispatch(setQuestionIndex(currentQuestionIndex + 1));
    } else if (parseInt(value) < testData.length + 1) {
      dispatch(setValue((parseInt(value) + 1).toString()));
      setCurrentQuestionIndex(0);
      dispatch(setQuestionIndex(0));
    } else {
      handleReview();
    }
  };

  const handleButtonClick = useCallback(
    (questionIndex) => {
      setCurrentQuestionIndex(questionIndex);
      dispatch(setQuestionIndex(questionIndex));
    },
    [dispatch],
  );

  useEffect(() => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    if (isMobile) {
      setShowQuestions(false);
    }
    if (value === null || value === undefined) {
      dispatch(setValue("2"));
    }
    if (questionIndex !== null) {
      handleButtonClick(questionIndex);
    }
  }, [value, questionIndex, dispatch, handleButtonClick]);

  const handleOverviewClick = () => {
    dispatch(setValue("1"));
  };

  function getTotalAttemptedQuestions() {
    let totalAttemptedQuestions = 0;
    if (selectedAnswers && typeof selectedAnswers === "object") {
      Object.keys(selectedAnswers).forEach((key) => {
        if (selectedAnswers[key].isAnswered) {
          totalAttemptedQuestions++;
        }
      });
    }
    return totalAttemptedQuestions;
  }

  const answeredPercentage = (getTotalAttemptedQuestions() / totalQue) * 100;

  const handleNext = () => {
    dispatch(setValue("2"));
  };

  function getSkillQuestionCount(skill) {
    return questionTypes?.reduce((acc, questionType) => {
      if (questionType in skill) {
        // Check if questionType is present
        return (
          acc +
          difficulties?.reduce((acc, difficulty) => {
            return (
              acc + (skill[questionType][`${difficulty}Questions`]?.length || 0)
            );
          }, 0)
        );
      }
      return acc;
    }, 0);
  }

  function getSkillTotalScore(skill) {
    return questionTypes?.reduce((acc, questionType) => {
      if (questionType in skill) {
        // Check if questionType is present
        return (
          acc +
          difficulties?.reduce((acc, difficulty) => {
            return (
              acc +
              (skill[questionType][`${difficulty}Questions`]?.reduce(
                (acc, question) => {
                  return (
                    acc +
                    question.score
                      .toString()
                      .split("")
                      .map(Number)
                      ?.reduce((a, b) => a + b, 0)
                  );
                },
                0,
              ) || 0)
            );
          }, 0)
        );
      }
      return acc;
    }, 0);
  }

  function getTypeQuestionCount(skill, type) {
    if (type in skill) {
      // Check if type is present
      return difficulties?.reduce((acc, difficulty) => {
        return acc + (skill[type][`${difficulty}Questions`]?.length || 0);
      }, 0);
    }
    return 0;
  }

  function getTypeScore(skill, type) {
    if (type in skill) {
      // Check if type is present
      return difficulties?.reduce((acc, difficulty) => {
        return (
          acc +
          (skill[type][`${difficulty}Questions`]?.reduce((acc, question) => {
            return (
              acc +
              question.score

                .toString()
                .split("")
                .map(Number)
                ?.reduce((a, b) => a + b, 0)
            );
          }, 0) || 0)
        );
      }, 0);
    }
    return 0;
  }

  function getTypeQuestions(skill, type) {
    if (type in skill) {
      // Check if type is present
      return difficulties?.reduce((acc, difficulty) => {
        return [
          ...acc,
          ...(skill[type][`${difficulty}Questions`]?.map((question) => {
            return question;
          }) || []),
        ];
      }, []);
    }
    return [];
  }

  useEffect(() => {
    const app = document.querySelector(".App");
    if (app) app.style.overflow = "hidden";
  }, []);

  return (
    <>
      <div
        className="App"
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          overflow: "hidden",
        }}
      >
        <div className="test-start-header" style={{ flexShrink: 0 }}>
          <ToastContainer />
          <Box
            className="test-container"
            sx={{
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
              padding: {
                base: "12px 14px",
                xs: "14px 16px",
                xss: "12px 18px",
                sm: "14px 20px",
                md: "16px 24px",
              },
              flex: 1,
              display: "flex",
              flexDirection: "column",
              gap: { base: "10px", xs: "12px", xss: "14px", sm: "14px" },
              minWidth: 0,
              border: "1px solid #f0f0f0",
            }}
          >
            {/* Main Content - Progressive: 3 rows → 2 rows → 1 row */}
            <Box
              sx={{
                display: "flex",
                flexDirection: {
                  base: "column",
                  sm: "row",
                },
                gap: {
                  base: "10px",
                  xs: "12px",
                  lg: "0",
                },
                alignItems: {
                  base: "flex-start",
                  lg: "center",
                },
                justifyContent: {
                  sm: "space-between",
                },
              }}
            >
              {/* Left Section - Test Info */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: {
                    base: "column",
                    lg: "row",
                  },
                  gap: {
                    base: "8px",
                    xs: "10px",
                    lg: "14px",
                  },
                  alignItems: {
                    base: "flex-start",
                    lg: "center",
                  },
                  flex: { lg: 1 },
                  minWidth: 0,
                }}
              >
                {/* Row 1 on mobile: Test Name */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: { base: "6px", xs: "8px", md: "10px" },
                    minWidth: 0,
                  }}
                >
                  <Box
                    component="img"
                    src={testSheet}
                    alt="Test Sheet Icon"
                    className="test-sheet-img"
                    sx={{
                      width: {
                        base: "22px",
                        xs: "22px",
                        xss: "24px",
                        sm: "26px",
                      },
                      height: {
                        base: "22px",
                        xs: "22px",
                        xss: "24px",
                        sm: "26px",
                      },
                      flexShrink: 0,
                    }}
                  />
                  <Tooltip
                    title={testName}
                    arrow
                    placement="bottom"
                    enterDelay={300}
                    leaveDelay={200}
                    slotProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#313131",
                          color: "#ffffff",
                          fontSize: "13px",
                          fontFamily: "'Roboto', sans-serif",
                          padding: "8px 12px",
                          borderRadius: "6px",
                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                          maxWidth: "400px",
                        },
                      },
                      arrow: {
                        sx: {
                          color: "#313131",
                        },
                      },
                    }}
                  >
                    <Box
                      component="h1"
                      sx={{
                        fontSize: {
                          base: "14px",
                          xs: "15px",
                          lg: "16px",
                        },
                        fontWeight: 700,
                        color: "#313131",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        margin: 0,
                        fontFamily: "'Roboto', sans-serif",
                        lineHeight: 1.2,
                        maxWidth: {
                          base: "70%",
                          xss: "100%",
                          lg: "500px",
                        },
                        cursor: "pointer",
                      }}
                    >
                      {testName}
                    </Box>
                  </Tooltip>
                </Box>

                {/* Divider - Hidden on mobile, visible on desktop */}
                <Box
                  sx={{
                    width: "1px",
                    height: "24px",
                    backgroundColor: "#e0e0e0",
                    flexShrink: 0,
                    display: {
                      base: "none",
                      lg: "block",
                    },
                  }}
                />

                {/* Row 2 on mobile: Company & Score */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: { base: "8px", xs: "10px", sm: "12px" },
                    flexWrap: {
                      base: "wrap",
                      lg: "nowrap",
                    },
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontSize: {
                        base: "12px",
                        xs: "13px",
                        sm: "13px",
                        md: "14px",
                      },
                      fontWeight: 500,
                      color: "#666",
                      display: "flex",
                      alignItems: "center",
                      gap: { base: "5px", xs: "6px" },
                      whiteSpace: "nowrap",
                      fontFamily: "'Roboto', sans-serif",
                      "& img": {
                        width: { base: "16px", xs: "17px", sm: "18px" },
                        height: { base: "16px", xs: "17px", sm: "18px" },
                        flexShrink: 0,
                      },
                    }}
                  >
                    <img src={CognizantColor} alt="" />
                    {company}
                  </Box>

                  <Box
                    sx={{
                      width: "1px",
                      height: { base: "18px", xs: "20px", sm: "22px" },
                      backgroundColor: "#e0e0e0",
                      flexShrink: 0,
                    }}
                  />

                  <Box
                    component="span"
                    sx={{
                      fontSize: {
                        base: "12px",
                        xs: "13px",
                        sm: "13px",
                        md: "14px",
                      },
                      fontWeight: 500,
                      color: "#666",
                      display: "flex",
                      alignItems: "center",
                      gap: { base: "5px", xs: "6px" },
                      whiteSpace: "nowrap",
                      fontFamily: "'Roboto', sans-serif",
                      "& img": {
                        width: { base: "16px", xs: "17px", sm: "18px" },
                        height: { base: "16px", xs: "17px", sm: "18px" },
                        flexShrink: 0,
                      },
                    }}
                  >
                    <img src={testScore} alt="" /> Test score: {totalScore}
                  </Box>
                </Box>
              </Box>

              {/* Right Section - Timer & Buttons */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: {
                    base: "6px",
                    xs: "8px",
                    xss: "8px",
                    sm: "10px",
                    md: "12px",
                  },
                  flexWrap: {
                    base: "wrap",
                    sm: "nowrap",
                  },
                  width: {
                    base: "100%",
                    sm: "auto",
                  },
                  justifyContent: {
                    base: "flex-start",
                    sm: "flex-end",
                  },
                }}
              >
                <Box
                  component="span"
                  className="clock-icon-text"
                  sx={{
                    background: "#fff0ea",
                    color: "#ff6812",
                    padding: {
                      base: "6px 9px",
                      xs: "7px 10px",
                      sm: "7px 12px",
                    },
                    borderRadius: "6px",
                    fontWeight: 600,
                    fontSize: {
                      base: "13px",
                      xs: "14px",
                      sm: "14px",
                      md: "15px",
                    },
                    display: "flex",
                    alignItems: "center",
                    gap: { base: "6px", xs: "7px", sm: "8px" },
                    border: "1px solid #ffe2d5",
                    whiteSpace: "nowrap",
                    fontFamily: "'Roboto', sans-serif",
                    lineHeight: 1.2,
                    "& img": {
                      width: { base: "16px", xs: "17px", sm: "18px" },
                      height: { base: "16px", xs: "17px", sm: "18px" },
                      flexShrink: 0,
                    },
                  }}
                >
                  <img src={clockIcon} alt="" /> {formatTime(remainingTime)}
                </Box>

                <Button
                  className="btn-overview"
                  onClick={() =>
                    handleNavigationAttempt(() => handleOverviewClick())
                  }
                  sx={{
                    border: "1px solid #00c49a",
                    color: "#00c49a",
                    backgroundColor: "#ffffff",
                    padding: {
                      base: "6px 10px",
                      xs: "7px 12px",
                      sm: "7px 14px",
                      md: "7px 16px",
                    },
                    fontSize: {
                      base: "12px",
                      xs: "13px",
                      sm: "13px",
                      md: "14px",
                    },
                    fontWeight: 600,
                    textTransform: "capitalize",
                    borderRadius: "6px",
                    minWidth: { base: "70px", xs: "80px", sm: "auto" },
                    lineHeight: 1.2,
                    whiteSpace: "nowrap",
                    fontFamily: "'Roboto', sans-serif",
                    "&:hover": {
                      backgroundColor: "#f0fdf9",
                      borderColor: "#00c49a",
                    },
                  }}
                >
                  Overview
                </Button>

                {/* Reset Test Button - Only visible in local development */}
                {window.location.hostname === "localhost" && (
                  <Button
                    className="btn-reset-test"
                    onClick={handleResetTest}
                    sx={{
                      backgroundColor: "#ff9800",
                      color: "#fff",
                      padding: {
                        base: "6px 10px",
                        xs: "7px 12px",
                        sm: "7px 14px",
                        md: "7px 16px",
                      },
                      fontSize: {
                        base: "12px",
                        xs: "13px",
                        sm: "13px",
                        md: "14px",
                      },
                      fontWeight: 600,
                      textTransform: "capitalize",
                      borderRadius: "6px",
                      border: "none",
                      minWidth: { base: "60px", xs: "70px", sm: "auto" },
                      lineHeight: 1.2,
                      whiteSpace: "nowrap",
                      fontFamily: "'Roboto', sans-serif",
                      "&:hover": {
                        backgroundColor: "#f57c00",
                      },
                    }}
                  >
                    Reset
                  </Button>
                )}

                <Button
                  className="btn-end-test"
                  onClick={() => handleNavigationAttempt(() => handleReview())}
                  sx={{
                    backgroundColor: "#ff6812",
                    color: "#fff",
                    padding: {
                      base: "6px 10px",
                      xs: "7px 12px",
                      sm: "7px 14px",
                      md: "7px 16px",
                    },
                    fontSize: {
                      base: "12px",
                      xs: "13px",
                      sm: "13px",
                      md: "14px",
                    },
                    fontWeight: 600,
                    textTransform: "capitalize",
                    borderRadius: "6px",
                    border: "none",
                    minWidth: { base: "70px", xs: "80px", sm: "auto" },
                    lineHeight: 1.2,
                    whiteSpace: "nowrap",
                    fontFamily: "'Roboto', sans-serif",
                    "&:hover": {
                      backgroundColor: "#e75907",
                    },
                  }}
                >
                  End Test
                </Button>
              </Box>
            </Box>

            {/* Progress Bar - Always at bottom */}
            <Box
              className="test-header-bottom"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: { base: "8px", xs: "10px", sm: "12px" },
              }}
            >
              <LinearProgress
                variant="determinate"
                value={answeredPercentage}
                sx={{
                  flex: 1,
                  height: { base: 6, xs: 7, sm: 8 },
                  borderRadius: 4,
                  backgroundColor: "#E8E9EE",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: "#00C49A",
                  },
                }}
              />
              <Box
                component="span"
                sx={{
                  fontSize: { base: "10px", xs: "11px", sm: "12px" },
                  fontWeight: 700,
                  color: "#555",
                  minWidth: { base: "35px", xs: "40px", sm: "45px" },
                }}
              >
                {answeredPercentage.toFixed(2)}%
              </Box>
            </Box>
          </Box>

          {showWebcam && (
            <Box
              className="user-img-test"
              onPointerDown={handleWebcamPointerDown}
              onPointerMove={handleWebcamPointerMove}
              onPointerUp={handleWebcamPointerUp}
              onPointerCancel={handleWebcamPointerUp}
              style={{
                transform: `translate(${webcamPos.x}px, ${webcamPos.y}px)`,
                touchAction: "none",
              }}
              sx={{
                position: {
                  base: "fixed",
                  xss: "fixed",
                  sm: "fixed",
                  md: "relative",
                },
                bottom: { base: "80px", xss: "80px", sm: "80px", md: "auto" },
                right: { base: "20px", xss: "20px", sm: "20px", md: "auto" },
                zIndex: { base: 9999, xss: 9999, sm: 9999, md: 1 },
                flexShrink: 0,
                alignSelf: { md: "stretch" },
                width: { md: "160px" },
                cursor: {
                  base: isDraggingWebcam ? "grabbing" : "grab",
                  xss: isDraggingWebcam ? "grabbing" : "grab",
                  sm: isDraggingWebcam ? "grabbing" : "grab",
                  md: "default",
                },
                "& .userimage": {
                  boxSizing: "border-box",
                  display: "block",
                  width: {
                    base: "120px",
                    md: "100%",
                  },
                  height: {
                    base: "100px",

                    md: "100%",
                  },
                  border: "3px solid #fff",
                  borderRadius: "8px",
                  objectFit: "cover",
                  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                  background: "#eee",
                },
              }}
            >
              <Webcam
                audio={false}
                mirrored={true}
                className="userimage"
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints}
                ref={webcamRef}
                onUserMedia={handleUserMedia}
                style={{
                  opacity: cameraStarted ? 1 : 0,
                  transition: "opacity 0.3s ease",
                }}
              />
              {!cameraStarted && (
                <img
                  src={userTestImage}
                  alt="Test Sheet Icon"
                  className="userimage"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    zIndex: -1,
                  }}
                />
              )}
            </Box>
          )}
        </div>
        <div
          className="test-tabs"
          style={{
            flex: 1,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            marginBottom: "8px",
          }}
        >
          <Box
            sx={{
              width: "100%",
              typography: "body1",
              flex: 1,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
            }}
          >
            <TabContext value={value || "1"}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={(e, v) =>
                    handleNavigationAttempt(() => handleChange(e, v))
                  }
                  aria-label="lab API tabs example"
                  variant="scrollable"
                  sx={{
                    overflowX: {
                      base: "auto",
                      sm: "hidden",
                    },
                    marginTop: 0,
                    "& .MuiTab-root": {
                      fontSize: {
                        base: "12px",
                        sm: "14px",
                      },
                      padding: {
                        base: "6px 10px",
                        sm: "10px 16px",
                      },
                      fontFamily: "'Roboto', sans-serif",
                    },
                  }}
                >
                  <Tab
                    className="tab-text"
                    label={`Overview (${totalQuestions})`}
                    value="1"
                    key="overview"
                  />
                  {testData?.map((test, index) => (
                    <Tab
                      className="tab-text"
                      label={`${test?.skill?.name} (${getSkillQuestionCount(
                        test,
                      )})`}
                      value={(index + 2).toString()}
                      key={index.toString()}
                    />
                  ))}
                </TabList>
              </Box>
              <TabPanel
                className="tab-pannel-box"
                sx={{
                  maxHeight: {
                    base: "calc(100vh - 180px)",
                    xs: "calc(100vh - 185px)",
                    xss: "calc(100vh - 190px)",
                    sm: "calc(100vh - 195px)",
                    md: "calc(100vh - 200px)",
                    lg: "calc(100vh - 200px)",
                  },
                  overflowY: "auto",
                  padding: {
                    base: "16px !important",
                  },
                }}
                value="1"
              >
                <Box
                  sx={{
                    flex: 1,
                    overflowY: "auto",
                    padding: "4px",
                  }}
                >
                  <Typography
                    component="h2"
                    sx={{
                      fontSize: {
                        base: "18px",
                        md: "22px",
                      },
                      fontWeight: 500,
                      margin: "4px 0 12px 0",
                      color: "#1a1a1a",
                      letterSpacing: "-0.02em",
                    }}
                  >
                    Test Overview
                  </Typography>
                  {testData?.map((skill, indexNew) => (
                    <Box
                      key={indexNew}
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "12px",
                        border: "1px solid #eef0f7",
                        boxShadow: "0 2px 12px rgba(0,0,0,0.02)",
                        marginBottom: "20px",
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        className="test-name-pannel"
                        sx={{
                          display: "flex",
                          flexDirection: {
                            base: "column",
                            sm: "row",
                          },
                          justifyContent: "space-between",
                          alignItems: {
                            base: "flex-start",
                            sm: "center",
                          },
                          padding: "8px 16px",
                          backgroundColor: "#f2f4f8",
                          borderBottom: "1px solid #f0f2f9",
                          gap: "12px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: { base: "8px", sm: "12px" },
                            flexWrap: "wrap",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            component="h3"
                            sx={{
                              margin: 0,
                              fontSize: {
                                base: "15px",
                                sm: "18px",
                              },
                              fontWeight: 700,
                              color: "#2d3436",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {skill?.skill?.name}
                            <Box
                              component="span"
                              sx={{
                                fontSize: "11px",
                                fontWeight: 500,
                                color: "#636e72",
                                backgroundColor: "#fff",
                                padding: "2px 8px",
                                borderRadius: "12px",
                                border: "1px solid #e2e8f0",
                              }}
                            >
                              {getSkillQuestionCount(skill)} Ques
                            </Box>
                          </Typography>

                          <Box
                            className="total-marks"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              fontSize: "13px",
                              fontWeight: 600,
                              color: "#636e72",
                              backgroundColor: "#fff",
                              padding: "4px 10px",
                              borderRadius: "20px",
                              border: "1px solid #edf2f7",
                              "& img": {
                                height: "14px",
                                marginRight: "6px",
                              },
                              "& span": {
                                color: "#00c49a",
                                fontWeight: 800,
                                marginLeft: "4px",
                              },
                            }}
                          >
                            <img
                              className="test-scoe-icon"
                              src={testScore}
                              alt=""
                            />
                            Total: <span>{getSkillTotalScore(skill)}</span>
                          </Box>
                        </Box>
                      </Box>
                      {questionTypes.map((questionType, index) => {
                        if (questionType in skill) {
                          return (
                            <Accordion
                              key={questionType}
                              defaultExpanded
                              className="accordion-pannel"
                              sx={{
                                boxShadow: "none !important",
                                "&:before": { display: "none" },
                                "&.Mui-expanded": { margin: 0 },
                                borderBottom: "1px solid #f0f2f9",
                                "&:last-child": { borderBottom: "none" },
                              }}
                            >
                              <AccordionSummary
                                className="pannel-revers"
                                expandIcon={
                                  <ExpandMoreIcon sx={{ fontSize: "1.2rem" }} />
                                }
                                sx={{
                                  padding: "0 20px",
                                  minHeight: "48px !important",
                                  "& .MuiAccordionSummary-content": {
                                    margin: "12px 0 !important",
                                  },
                                  "&:hover": { backgroundColor: "#fafbfc" },
                                }}
                              >
                                <Box
                                  className="expand-more"
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    gap: "10px",
                                  }}
                                >
                                  <Typography
                                    className="question-name"
                                    sx={{
                                      fontSize: {
                                        base: "14px",
                                        sm: "15px",
                                      },
                                      fontWeight: 700,
                                      color: "#4a5568",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {`${capitalize(
                                      questionType.split("Questions")[0],
                                    )}`}
                                    <Box
                                      component="span"
                                      sx={{
                                        color: "#a0aec0",
                                        fontWeight: 500,
                                        ml: 1,
                                      }}
                                    >
                                      (
                                      {getTypeQuestionCount(
                                        skill,
                                        questionType,
                                      )}
                                      )
                                    </Box>
                                  </Typography>
                                  <Box
                                    className="skills-score"
                                    sx={{
                                      fontSize: {
                                        base: "11px",
                                        sm: "12px",
                                      },
                                      fontWeight: {
                                        base: 500,
                                        sm: 600,
                                      },
                                      color: "#00c49a",
                                      backgroundColor:
                                        "rgba(0, 196, 154, 0.08)",
                                      padding: "2px 8px",
                                      borderRadius: "4px",
                                      border:
                                        "1px solid rgba(0, 196, 154, 0.2)",
                                      "& span": {
                                        fontWeight: 800,
                                        marginLeft: "4px",
                                      },
                                    }}
                                  >
                                    SCORE:{" "}
                                    <span>
                                      {getTypeScore(skill, questionType)}
                                    </span>
                                  </Box>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails
                                sx={{ padding: "0 20px 15px 20px" }}
                              >
                                <Typography>
                                  {(() => {
                                    const allQuestions = getTypeQuestions(
                                      skill,
                                      questionType,
                                    );

                                    return allQuestions.map(
                                      (question, index) => (
                                        <Box
                                          className="question-list"
                                          key={index}
                                          sx={{
                                            display: "flex",
                                            flexDirection: {
                                              base: "column",
                                              sm: "row",
                                            },
                                            justifyContent: "space-between",
                                            alignItems: {
                                              base: "flex-start",
                                              sm: "center",
                                            },
                                            padding: "12px",
                                            borderRadius: "8px",
                                            marginBottom: "8px",
                                            border: "1px solid #f1f5f9",
                                            backgroundColor: "#fcfdff",
                                            transition: "all 0.2s",
                                            gap: "12px",
                                            "&:hover": {
                                              backgroundColor: "#fff",
                                              borderColor: "#00c49a",
                                              boxShadow:
                                                "0 2px 8px rgba(0,196,154,0.05)",
                                            },
                                          }}
                                        >
                                          <Box
                                            className="question"
                                            sx={{
                                              cursor: "pointer",
                                              flex: 1,
                                              fontSize: {
                                                base: "13px",
                                                sm: "14px",
                                              },
                                              fontWeight: 600,
                                              color: "#334155",
                                              display: "flex",
                                              alignItems: "flex-start",
                                              gap: "8px",
                                              width: "100%",
                                              "&:hover": {
                                                color: "#00c49a",
                                              },
                                            }}
                                            onClick={(event) =>
                                              handleNavigationAttempt(() =>
                                                handleChangeNew(
                                                  event,
                                                  String(indexNew + 2),
                                                  index,
                                                ),
                                              )
                                            }
                                          >
                                            <Box
                                              component="span"
                                              sx={{
                                                color: "#94a3b8",
                                                fontWeight: 500,
                                                minWidth: "18px",
                                              }}
                                            >
                                              {index + 1}.
                                            </Box>
                                            <Box component="span">
                                              {question.questionTitle}
                                            </Box>
                                          </Box>
                                          <Box
                                            className="question-check-style"
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "12px",
                                              width: {
                                                base: "100%",
                                                sm: "auto",
                                              },
                                              justifyContent: {
                                                base: "flex-start",
                                                sm: "flex-end",
                                              },
                                              paddingLeft: {
                                                base: "26px",
                                                sm: 0,
                                              },
                                            }}
                                          >
                                            <Typography
                                              className="question-check-style-number"
                                              sx={{
                                                fontSize: "11px",
                                                fontWeight: 700,
                                                color: "#64748b",
                                                backgroundColor: "#f8fafc",
                                                padding: "3px 10px",
                                                borderRadius: "6px",
                                                border: "1px solid #e2e8f0",
                                                minWidth: "55px",
                                                textAlign: "center",
                                              }}
                                            >
                                              Score: {question.score}
                                            </Typography>

                                            {(() => {
                                              const isDone =
                                                selectedAnswers[question._id]
                                                  ?.isAnswered;
                                              return (
                                                <Box
                                                  sx={{
                                                    fontSize: "10px",
                                                    fontWeight: 800,
                                                    padding: "4px 12px",
                                                    borderRadius: "6px",
                                                    textTransform: "uppercase",
                                                    backgroundColor: isDone
                                                      ? "rgba(0, 196, 154, 0.1)"
                                                      : "#f1f5f9",
                                                    color: isDone
                                                      ? "#00c49a"
                                                      : "#64748b",
                                                    minWidth: {
                                                      base: "80px",
                                                      sm: "95px",
                                                    },
                                                    textAlign: "center",
                                                    border: "1px solid",
                                                    borderColor: isDone
                                                      ? "rgba(0, 196, 154, 0.2)"
                                                      : "#e2e8f0",
                                                    letterSpacing: "0.03em",
                                                  }}
                                                >
                                                  {isDone
                                                    ? "Answered"
                                                    : "Pending"}
                                                </Box>
                                              );
                                            })()}
                                          </Box>
                                        </Box>
                                      ),
                                    );
                                  })()}
                                </Typography>
                              </AccordionDetails>
                            </Accordion>
                          );
                        }
                      })}
                    </Box>
                  ))}
                </Box>
                {/* Fixed bottom footers matching the white card background */}
                <Box
                  className="footer-btn-next"
                  sx={{
                    padding: "16px 20px",
                    borderTop: "1px solid #eef0f7",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    backgroundColor: "#fff",
                  }}
                >
                  <Button
                    onClick={handleNext}
                    endIcon={<ChevronRight />}
                    sx={{
                      backgroundColor: "#00c49a",
                      color: "#fff",
                      padding: {
                        base: "10px 24px",
                      },
                      fontSize: "15px",
                      fontWeight: 700,
                      textTransform: "none",
                      borderRadius: "8px",
                      boxShadow: "0 4px 12px rgba(0, 196, 154, 0.25)",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      "& .MuiButton-endIcon": {
                        transition: "transform 0.3s ease",
                      },
                      "&:hover": {
                        backgroundColor: "#00b38c",
                        boxShadow: "0 6px 16px rgba(0, 196, 154, 0.35)",
                        transform: "translateY(-2px)",
                        "& .MuiButton-endIcon": {
                          transform: "translateX(4px)",
                        },
                      },
                      "&:active": {
                        transform: "translateY(0)",
                      },
                    }}
                  >
                    Next
                  </Button>
                </Box>
                <Box
                  className="footer-logo footer-bg-white"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: "#fff",
                    paddingBottom: "12px",
                  }}
                >
                  <img
                    src={WhoWeAreImgpowerd}
                    alt=""
                    className="who-wer-are-p-img"
                    style={{ height: "24px", opacity: 0.7 }}
                  />
                </Box>
              </TabPanel>

              <TabPanel
                className="tab-panel-box start-question-answer"
                sx={{
                  flex: 1,
                  minHeight: 0,
                  overflowY: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  padding: 0,
                }}
                value={`${value?.toString()}`}
              >
                {testData && testData?.length > 0 && testData[value - 2] && (
                  <div
                    className="question-main-test"
                    style={{
                      minHeight: 0,
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        flex: 1,
                        minHeight: 0,
                      }}
                    >
                      <Box
                        className="question-left"
                        sx={{
                          width: {
                            base: showQuestions ? "100%" : "50px",
                            xs: showQuestions ? "100%" : "55px",
                            xss: showQuestions ? "240px" : "55px",
                            sm: showQuestions ? "260px" : "60px",
                            md: showQuestions ? "280px" : "65px",
                            lg: showQuestions ? "300px" : "65px",
                            xl: showQuestions ? "320px" : "65px",
                          },
                          transition: "width 0.3s ease",
                          borderRight: "1px solid #e0e0e0",
                          borderRadius: "12px 0 0 12px",
                          display: "flex",
                          flexDirection: "column",
                          backgroundColor: "#fff",
                          position: {
                            base: showQuestions ? "fixed" : "relative",
                            xs: showQuestions ? "fixed" : "relative",
                            xss: "relative",
                          },
                          top: { base: 0, xs: 0, xss: "auto" },
                          left: { base: 0, xs: 0, xss: "auto" },
                          height: {
                            base: showQuestions ? "100vh" : "auto",
                            xs: showQuestions ? "100vh" : "auto",
                            xss: "auto",
                          },
                          alignSelf: "stretch",
                          zIndex: {
                            base: showQuestions ? 1000 : 1,
                            xs: showQuestions ? 1000 : 1,
                            xss: 1,
                          },
                          boxShadow: {
                            base: showQuestions
                              ? "2px 0 10px rgba(0,0,0,0.1)"
                              : "none",
                            xs: showQuestions
                              ? "2px 0 10px rgba(0,0,0,0.1)"
                              : "none",
                            xss: "none",
                          },
                        }}
                      >
                        {/* Header */}
                        <Box
                          className="question-heading"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: showQuestions
                              ? "space-between"
                              : "center",
                            padding: {
                              base: "10px",
                              xs: "12px",
                              sm: "14px",
                            },
                            borderBottom: "1px solid #f0f0f0",
                            height: {
                              base: "40px",
                              xs: "44px",
                              sm: "48px",
                            },
                          }}
                        >
                          {showQuestions && (
                            <Typography
                              component="h2"
                              sx={{
                                margin: 0,
                                fontSize: {
                                  base: "16px",
                                  xs: "17px",
                                  xss: "17px",
                                  sm: "18px",
                                  md: "18px",
                                  lg: "18px",
                                },
                                fontWeight: "600",
                                color: "#333",
                                fontFamily: "'Roboto', sans-serif",
                              }}
                            >
                              Questions
                            </Typography>
                          )}
                          <Box
                            className="toggle-sidebar-btn"
                            onClick={() => setShowQuestions(!showQuestions)}
                            sx={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: {
                                base: "30px",
                                xs: "32px",
                                sm: "34px",
                              },
                              height: {
                                base: "30px",
                                xs: "32px",
                                sm: "34px",
                              },
                              borderRadius: "4px",
                              backgroundColor: "#fff",
                              boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                              color: "#555",
                              transition: "all 0.2s ease",
                              border: "1px solid #eee",
                              "&:hover": {
                                backgroundColor: "#f5f5f5",
                                boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                              },
                            }}
                            title={
                              showQuestions
                                ? "Collapse Sidebar"
                                : "Expand Sidebar"
                            }
                          >
                            {showQuestions ? (
                              <ChevronLeft fontSize="small" />
                            ) : (
                              <ChevronRight fontSize="small" />
                            )}
                          </Box>
                        </Box>

                        {/* Legend Section (New Design) */}
                        {showQuestions && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: {
                                base: "10px",
                                xs: "12px",
                                xss: "14px",
                                sm: "15px",
                                md: "16px",
                              },
                              padding: {
                                base: "8px 6px",
                                xs: "9px 7px",
                                sm: "10px 8px",
                              },
                              backgroundColor: "#fafafa",
                              borderBottom: "1px solid #f0f0f0",
                              flexWrap: "wrap",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: {
                                  base: "10px",
                                  xs: "10.5px",
                                  xss: "11px",
                                  sm: "12px",
                                },
                                color: "#666",
                                fontWeight: 500,
                                fontFamily: "'Roboto', sans-serif",
                              }}
                            >
                              <Box
                                sx={{
                                  width: {
                                    base: "10px",

                                    md: "12px",
                                  },
                                  height: {
                                    base: "10px",

                                    md: "12px",
                                  },
                                  borderRadius: "2px",
                                  border: "2px solid #ff725e",
                                  marginRight: {
                                    base: "5px",
                                    xss: "6px",
                                  },
                                  backgroundColor: "#fff",
                                }}
                              ></Box>
                              Current
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: {
                                  base: "10px",
                                  xs: "10.5px",
                                  xss: "11px",
                                  sm: "12px",
                                },
                                color: "#666",
                                fontWeight: 500,
                                fontFamily: "'Roboto', sans-serif",
                              }}
                            >
                              <Box
                                sx={{
                                  width: {
                                    base: "10px",

                                    md: "12px",
                                  },
                                  height: {
                                    base: "10px",

                                    md: "12px",
                                  },
                                  borderRadius: "2px",
                                  backgroundColor: "#ff9800",
                                  marginRight: {
                                    base: "5px",
                                    xss: "6px",
                                  },
                                }}
                              ></Box>
                              Review
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: {
                                  base: "10px",
                                  xss: "11px",
                                  sm: "12px",
                                },
                                color: "#666",
                                fontWeight: 500,
                                fontFamily: "'Roboto', sans-serif",
                              }}
                            >
                              <Box
                                sx={{
                                  width: {
                                    base: "10px",

                                    md: "12px",
                                  },
                                  height: {
                                    base: "10px",

                                    md: "12px",
                                  },
                                  borderRadius: "2px",
                                  backgroundColor: "#2dce89",
                                  marginRight: {
                                    base: "5px",
                                    xs: "5px",
                                    xss: "6px",
                                    sm: "6px",
                                    md: "6px",
                                  },
                                }}
                              ></Box>
                              Answered
                            </Box>
                          </Box>
                        )}

                        {/* Expanded Content */}
                        {showQuestions && (
                          <>
                            <Box
                              className="question-heading"
                              sx={{
                                maxHeight: "calc(100vh - 280px)",
                                overflowY: "auto",
                                // Invisible scrollbar
                                WebkitOverflowScrolling: "touch",
                                scrollbarWidth: "none",
                                MsOverflowStyle: "none",
                                "&::-webkit-scrollbar": {
                                  display: "none",
                                },
                                padding: "0 10px",
                              }}
                            >
                              {(() => {
                                let overallIdx = 0;
                                return questionTypes.map(
                                  (questionType, typeIdx) => {
                                    if (questionType in testData[value - 2]) {
                                      const qs = getTypeQuestions(
                                        testData[value - 2],
                                        questionType,
                                      );
                                      if (qs.length === 0) return null;
                                      return (
                                        <div key={typeIdx}>
                                          <h3
                                            style={{
                                              fontSize: "13px",
                                              marginTop: "12px",
                                              marginBottom: "6px",
                                              color: "#555",
                                            }}
                                          >
                                            {capitalize(
                                              questionType.split(
                                                "Questions",
                                              )[0],
                                            )}{" "}
                                            ({qs.length})
                                          </h3>
                                          <Box
                                            className="grp-btn"
                                            sx={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: "8px",
                                              padding: "4px 0",
                                            }}
                                          >
                                            {qs.map((question, idx) => {
                                              const currentIndexForBtn =
                                                overallIdx++;
                                              let reviewClassName = "";
                                              if (
                                                selectedAnswers[question._id] &&
                                                selectedAnswers[question._id]
                                                  .isReviewed
                                              ) {
                                                reviewClassName =
                                                  "review-question";
                                              } else if (
                                                selectedAnswers[question._id] &&
                                                selectedAnswers[question._id]
                                                  .isAnswered
                                              ) {
                                                reviewClassName =
                                                  "answered-question";
                                              } else {
                                                reviewClassName = "default-btn";
                                              }

                                              const currentQuestionClass =
                                                currentQuestionIndex ===
                                                currentIndexForBtn
                                                  ? "current-question"
                                                  : "";

                                              return (
                                                <Button
                                                  key={question._id}
                                                  variant="outlined"
                                                  className={`${reviewClassName} ${currentQuestionClass}`}
                                                  onClick={() =>
                                                    handleNavigationAttempt(
                                                      () =>
                                                        handleButtonClick(
                                                          currentIndexForBtn,
                                                        ),
                                                    )
                                                  }
                                                  sx={{
                                                    minWidth: {
                                                      base: "28px",
                                                      sm: "32px",
                                                    },
                                                    width: {
                                                      base: "28px",
                                                      sm: "32px",
                                                    },
                                                    height: {
                                                      base: "28px",
                                                      sm: "32px",
                                                    },
                                                    borderRadius: "4px",
                                                    padding: 0,
                                                    border:
                                                      "1px solid !important",
                                                    boxShadow: "none",
                                                    fontSize: {
                                                      base: "12px",
                                                      sm: "13px",
                                                    },
                                                  }}
                                                >
                                                  {currentIndexForBtn + 1}
                                                </Button>
                                              );
                                            })}
                                          </Box>
                                        </div>
                                      );
                                    }
                                    return null;
                                  },
                                );
                              })()}
                            </Box>
                            <Box
                              className="left-nav-logo"
                              sx={{
                                padding: "16px",
                                display: "flex",
                                justifyContent: "center",
                                borderTop: "1px solid #f0f0f0",
                                mt: "auto",
                              }}
                            >
                              <img
                                src={WhoWeAreImgpowerd}
                                alt=""
                                className="left-nav-logo-img"
                                style={{ height: "20px", opacity: 0.8 }}
                              />
                            </Box>
                          </>
                        )}

                        {/* Collapsed Content */}
                        {!showQuestions && (
                          <Box
                            sx={{
                              flex: 1,
                              overflowY: "auto",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              paddingTop: "16px",
                              gap: "12px",
                              // Hide scrollbar
                              scrollbarWidth: "none",
                              "&::-webkit-scrollbar": {
                                display: "none",
                              },
                            }}
                          >
                            {(() => {
                              let overallIdx = 0;
                              return questionTypes.map((questionType) => {
                                if (questionType in testData[value - 2]) {
                                  const qs = getTypeQuestions(
                                    testData[value - 2],
                                    questionType,
                                  );
                                  return qs.map((question) => {
                                    const currentIndexForBtn = overallIdx++;
                                    let reviewClassName = "";
                                    if (
                                      selectedAnswers[question._id] &&
                                      selectedAnswers[question._id].isReviewed
                                    ) {
                                      reviewClassName = "review-question";
                                    } else if (
                                      selectedAnswers[question._id] &&
                                      selectedAnswers[question._id].isAnswered
                                    ) {
                                      reviewClassName = "answered-question";
                                    } else {
                                      reviewClassName = "default-btn";
                                    }

                                    const currentQuestionClass =
                                      currentQuestionIndex ===
                                      currentIndexForBtn
                                        ? "current-question"
                                        : "";

                                    return (
                                      <Button
                                        key={question._id}
                                        variant="outlined"
                                        className={`${reviewClassName} ${currentQuestionClass}`}
                                        onClick={() =>
                                          handleNavigationAttempt(() =>
                                            handleButtonClick(
                                              currentIndexForBtn,
                                            ),
                                          )
                                        }
                                        sx={{
                                          minWidth: {
                                            base: "28px",
                                          },
                                          width: {
                                            base: "28px",
                                          },
                                          height: {
                                            base: "28px",
                                          },
                                          borderRadius: "4px",
                                          padding: 0,
                                          fontSize: {
                                            base: "12px",
                                            sm: "13px",
                                          },
                                          border: "1px solid !important",
                                        }}
                                      >
                                        {currentIndexForBtn + 1}
                                      </Button>
                                    );
                                  });
                                }
                                return null;
                              });
                            })()}
                          </Box>
                        )}
                      </Box>
                      <Box
                        className="question-parent-container"
                        sx={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          backgroundColor: "#fcfdff",
                          borderRadius: "0 12px 12px 0",
                          border: "1px solid #eef0f7",
                          margin: 0,
                          overflow: "hidden",
                        }}
                      >
                        <Box
                          className="question-right"
                          sx={{
                            flex: 1,
                            overflowY: "auto",
                            overflowX: "hidden",
                            width: "100%",
                            WebkitOverflowScrolling: "touch",
                            padding: {
                              base: "10px",
                              xss: "12px",
                              sm: "14px 16px",
                              md: "16px 20px",
                            },
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "stretch",
                            "&::-webkit-scrollbar": {
                              width: "6px",
                            },
                            "&::-webkit-scrollbar-track": {
                              backgroundColor: "transparent",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              backgroundColor: "#e2e8f0",
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                              backgroundColor: "#cbd5e0",
                            },
                          }}
                        >
                          <Box sx={{ minWidth: "100%", maxWidth: "100%" }}>
                            {currentSkillQuestions[currentQuestionIndex] &&
                              (() => {
                                const question =
                                  currentSkillQuestions[currentQuestionIndex];
                                const qIdx = currentQuestionIndex;
                                const questionType = question.questionType;
                                const difficulty = question.difficulty;

                                return (
                                  <div
                                    className="question-start"
                                    key={question._id}
                                    style={{
                                      height:
                                        questionType === "programmingQuestions"
                                          ? "100%"
                                          : "auto",
                                      width: "100%",
                                    }}
                                  >
                                    {questionType === "programmingQuestions" ? (
                                      <ProgrammingTypeQuestion
                                        ref={programmingQuestionRef}
                                        data={question}
                                        selectedAnswerData={
                                          selectedAnswers[question._id]
                                        }
                                        timeRemaining={remainingTime}
                                        handleNext={async (pData) => {
                                          await submitAnswer(
                                            question._id,
                                            {
                                              selectedAnswer:
                                                pData.candidateAnswer,
                                              isAnswered: true,
                                              isReviewed: false,
                                              timeSpent: pData.timeSpent,
                                              retakes: pData.retakes || 0,
                                            },
                                            testData[value - 2].skill._id,
                                            questionType,
                                            difficulty,
                                            {
                                              code: pData.code,
                                              programmingLanguageId:
                                                pData.programmingLanguageId,
                                              isCheatingDetected:
                                                pData.isCheatingDetected,
                                              detectedCheatings:
                                                pData.detectedCheatings,
                                              skillName: pData.skill,
                                            },
                                          );
                                          handleNextQuestion();
                                        }}
                                        handleUpdate={async (pData) => {
                                          // Use thunk-style dispatch to get absolute latest state and avoid stale closure issues
                                          dispatch(
                                            (dispatchState, getState) => {
                                              const state = getState();
                                              const currentAnswer =
                                                state.testReducer
                                                  .selectedAnswers[
                                                  question._id
                                                ] || {};

                                              // Storing cheatings in Redux
                                              dispatch(
                                                recordQuestionCheating(
                                                  question._id,
                                                  pData.detectedCheatings,
                                                ),
                                              );

                                              // Keep isAnswered true if it's already true in Redux
                                              const finalIsAnswered =
                                                currentAnswer.isAnswered ||
                                                false;

                                              dispatch(
                                                setAnswer(
                                                  question._id,
                                                  pData.candidateAnswer,
                                                  finalIsAnswered,
                                                  false,
                                                  pData.timeSpent,
                                                  pData.retakes || 0,
                                                  pData.programmingLanguageId,
                                                ),
                                              );
                                            },
                                          );
                                        }}
                                        questionIndex={qIdx}
                                        practiceMode={false}
                                        onAttemptsStatusChange={
                                          setIsProgrammingAttemptsExhausted
                                        }
                                      />
                                    ) : (
                                      <>
                                        <Box className="question-no-start">
                                          <Box
                                            className="question-header-row"
                                            sx={{
                                              display: "flex",
                                              flexDirection: {
                                                base: "column",
                                                sm: "row",
                                              },
                                              alignItems: {
                                                base: "flex-start",
                                                sm: "center",
                                              },
                                              justifyContent: "space-between",
                                              gap: "12px",
                                              marginBottom: "12px",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                fontSize: {
                                                  base: "15px",
                                                  sm: "18px",
                                                },
                                                fontWeight: 600,
                                                lineHeight: 1.2,
                                                color: "#1a1a1a",
                                                letterSpacing: "-0.01em",
                                              }}
                                            >
                                              {`Q${qIdx + 1}. ${
                                                question.questionTitle
                                              }`}
                                            </Box>

                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                              }}
                                            >
                                              {/* <Button
                                                className="mobile-questin-view"
                                                onClick={handleMobile}
                                                sx={{
                                                  display: {
                                                    base: "inline-flex",
                                                    sm: "none",
                                                  },
                                                  minWidth: "auto",
                                                  padding: "4px",
                                                  border: "1px solid #e2e8f0",
                                                  borderRadius: "6px",
                                                }}
                                              >
                                                <img
                                                  src={mobileViewQs}
                                                  alt=""
                                                  style={{ height: "16px" }}
                                                />
                                              </Button> */}
                                              <Button
                                                className="reset-btn"
                                                onClick={() => {
                                                  submitAnswer(
                                                    question._id,
                                                    {
                                                      selectedAnswer: null,
                                                      isAnswered: false,
                                                      retakes: 0,
                                                      isReviewed:
                                                        selectedAnswers?.[
                                                          question._id
                                                        ]?.isReviewed,
                                                    },
                                                    testData[value - 2].skill
                                                      ._id,
                                                    questionType,
                                                    difficulty,
                                                  );
                                                }}
                                                sx={{
                                                  fontSize: {
                                                    base: "12px",
                                                    sm: "14px",
                                                  },
                                                  textTransform: "none",
                                                  fontWeight: 600,
                                                  color: "#64748b",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "4px",
                                                  padding: "3px 8px",
                                                  borderRadius: "5px",
                                                  border: "1px solid #e2e8f0",
                                                  "& img": {
                                                    height: {
                                                      base: "12px",
                                                      sm: "16px",
                                                    },
                                                    width: {
                                                      base: "12px",
                                                      sm: "16px",
                                                    },
                                                  },
                                                  "&:hover": {
                                                    backgroundColor: "#f8fafc",
                                                  },
                                                }}
                                              >
                                                <img src={resetAns} alt="" />
                                                Reset
                                              </Button>
                                              <Box
                                                sx={{
                                                  fontSize: {
                                                    base: "12px",
                                                    sm: "14px",
                                                  },
                                                  fontWeight: 700,
                                                  color: "#00c49a",
                                                  backgroundColor:
                                                    "rgba(0, 196, 154, 0.08)",
                                                  padding: "3px 8px",
                                                  borderRadius: "5px",
                                                  border:
                                                    "1px solid rgba(0, 196, 154, 0.2)",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "4px",
                                                  whiteSpace: "nowrap",
                                                  "& img": {
                                                    height: {
                                                      base: "12px",
                                                      sm: "16px",
                                                    },
                                                    width: {
                                                      base: "12px",
                                                      sm: "16px",
                                                    },
                                                  },
                                                }}
                                              >
                                                <img src={maxScore} alt="" />
                                                Points: {question.score}
                                              </Box>
                                            </Box>
                                          </Box>

                                          <Divider
                                            sx={{
                                              width: "100%",
                                              borderColor: "#8e8e91",
                                              mb: 2,
                                            }}
                                          />

                                          <Box
                                            sx={{
                                              display: "flex",
                                              flexDirection: {
                                                base: "column",
                                                md: "row",
                                              },
                                              gap: { base: "10px", md: "16px" },
                                              alignItems: "flex-start",
                                              width: "100%",
                                            }}
                                          >
                                            {/* Left Column: Question Content */}
                                            <Box
                                              sx={{
                                                flex: {
                                                  base: "1 1 auto",
                                                  md: 1,
                                                },
                                                width: {
                                                  base: "100%",
                                                },
                                                minWidth: 0,
                                              }}
                                            >
                                              <Box
                                                sx={{
                                                  "& .sun-editor-editable": {
                                                    fontSize: {
                                                      base: "15px",
                                                      sm: "16px",
                                                    },
                                                    lineHeight: 1.6,
                                                    color: "#334155",
                                                    wordBreak: "break-word",
                                                  },
                                                }}
                                              >
                                                <div
                                                  className="sun-editor-editable"
                                                  dangerouslySetInnerHTML={{
                                                    __html: question.question,
                                                  }}
                                                />
                                              </Box>
                                            </Box>

                                            <Divider
                                              orientation="vertical"
                                              flexItem
                                              sx={{
                                                display: {
                                                  base: "none",
                                                  md: "block",
                                                },
                                                borderColor: "#8e8e91",
                                                borderWidth: "1px",
                                              }}
                                            />
                                            <Divider
                                              sx={{
                                                display: {
                                                  base: "block",
                                                  md: "none",
                                                },
                                                width: "100%",
                                                borderColor: "#8e8e91",
                                                borderWidth: "1px",
                                              }}
                                            />

                                            {/* Right Column: Options */}
                                            <Box
                                              sx={{
                                                flex: {
                                                  base: "1 1 auto",
                                                  md: 1,
                                                },
                                                width: {
                                                  base: "100%",
                                                },
                                                minWidth: 0,
                                              }}
                                            >
                                              {question.multipleAnswers ? (
                                                <FormControl fullWidth>
                                                  <Stack
                                                    spacing={0.8}
                                                    direction="column"
                                                  >
                                                    {question?.answers?.map(
                                                      (answer, answerIndex) => (
                                                        <FormControlLabel
                                                          key={`${questionType}-${difficulty}-${qIdx}-${answerIndex}`}
                                                          sx={{
                                                            margin: 0,
                                                            width: "100%",
                                                            padding: "8px 12px",
                                                            borderRadius: "8px",
                                                            border:
                                                              "1.5px solid",
                                                            borderColor:
                                                              selectedAnswers?.[
                                                                question._id
                                                              ]?.selectedAnswer?.includes(
                                                                answer.optionId,
                                                              )
                                                                ? "#00c49a"
                                                                : "#f1f5f9",
                                                            backgroundColor:
                                                              selectedAnswers?.[
                                                                question._id
                                                              ]?.selectedAnswer?.includes(
                                                                answer.optionId,
                                                              )
                                                                ? "rgba(0, 196, 154, 0.04)"
                                                                : "#fff",
                                                            transition:
                                                              "all 0.2s",
                                                            "&:hover": {
                                                              borderColor:
                                                                "#00c49a",
                                                              transform:
                                                                "translateX(2px)",
                                                            },
                                                            "& .MuiTypography-root":
                                                              {
                                                                width: "100%",
                                                                fontSize:
                                                                  "14px",
                                                                fontWeight: 500,
                                                                color:
                                                                  "#334155",
                                                                wordBreak:
                                                                  "break-word",
                                                                overflowWrap:
                                                                  "anywhere",
                                                                whiteSpace:
                                                                  "normal",
                                                              },
                                                            "& .sun-editor-editable":
                                                              {
                                                                backgroundColor:
                                                                  "transparent !important",
                                                                wordBreak:
                                                                  "break-word",
                                                                overflowWrap:
                                                                  "anywhere",
                                                                whiteSpace:
                                                                  "normal",
                                                              },
                                                          }}
                                                          control={
                                                            <Checkbox
                                                              checked={selectedAnswers?.[
                                                                question._id
                                                              ]?.selectedAnswer?.includes(
                                                                answer.optionId,
                                                              )}
                                                              sx={{
                                                                padding: "2px",
                                                                marginRight:
                                                                  "8px",
                                                                "&.Mui-checked":
                                                                  {
                                                                    color:
                                                                      "#00c49a",
                                                                  },
                                                              }}
                                                              onChange={(
                                                                event,
                                                              ) => {
                                                                const currentSelectedAnswers =
                                                                  selectedAnswers?.[
                                                                    question._id
                                                                  ]
                                                                    ?.selectedAnswer ||
                                                                  [];

                                                                let newSelectedAnswers;

                                                                if (
                                                                  event.target
                                                                    .checked
                                                                ) {
                                                                  newSelectedAnswers =
                                                                    [
                                                                      ...currentSelectedAnswers,
                                                                      answer.optionId,
                                                                    ];
                                                                } else {
                                                                  newSelectedAnswers =
                                                                    currentSelectedAnswers.filter(
                                                                      (id) =>
                                                                        id !==
                                                                        answer.optionId,
                                                                    );
                                                                }

                                                                const newValue =
                                                                  {
                                                                    selectedAnswer:
                                                                      newSelectedAnswers,
                                                                    isAnswered:
                                                                      newSelectedAnswers?.length >
                                                                      0,
                                                                    isReviewed:
                                                                      selectedAnswers?.[
                                                                        question
                                                                          ._id
                                                                      ]
                                                                        ?.isReviewed,
                                                                  };

                                                                submitAnswer(
                                                                  question._id,
                                                                  newValue,
                                                                  testData[
                                                                    value - 2
                                                                  ].skill._id,
                                                                  questionType,
                                                                  difficulty,
                                                                );
                                                              }}
                                                            />
                                                          }
                                                          label={
                                                            <div
                                                              className="sun-editor-editable"
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  answer.option,
                                                              }}
                                                            />
                                                          }
                                                        />
                                                      ),
                                                    )}
                                                  </Stack>
                                                </FormControl>
                                              ) : (
                                                <RadioGroup
                                                  onKeyDown={(event) => {
                                                    if (
                                                      event.key === "ArrowUp" ||
                                                      event.key ===
                                                        "ArrowDown" ||
                                                      event.key ===
                                                        "ArrowRight" ||
                                                      event.key === "ArrowLeft"
                                                    ) {
                                                      event.preventDefault();
                                                    }
                                                  }}
                                                  aria-labelledby="radio-buttons-group-label"
                                                  value={
                                                    selectedAnswers &&
                                                    selectedAnswers[
                                                      question._id
                                                    ] &&
                                                    selectedAnswers[
                                                      question._id
                                                    ].selectedAnswer !==
                                                      undefined
                                                      ? selectedAnswers[
                                                          question._id
                                                        ].selectedAnswer
                                                      : null
                                                  }
                                                  onChange={(event) => {
                                                    const newValue = {
                                                      selectedAnswer:
                                                        event.target.value ??
                                                        null,
                                                      isAnswered: true,
                                                      isReviewed:
                                                        selectedAnswers?.[
                                                          question._id
                                                        ]?.isReviewed,
                                                    };

                                                    submitAnswer(
                                                      question._id,
                                                      newValue,
                                                      testData[value - 2].skill
                                                        ._id,
                                                      questionType,
                                                      difficulty,
                                                    );
                                                  }}
                                                  name="radio-buttons-group"
                                                  className="radio-btn"
                                                  sx={{ width: "100%" }}
                                                >
                                                  <Stack spacing={0.8}>
                                                    {question?.answers?.map(
                                                      (answer, answerIndex) => (
                                                        <FormControlLabel
                                                          key={`${questionType}-${difficulty}-${qIdx}-${answerIndex}`}
                                                          sx={{
                                                            margin: 0,
                                                            width: "100%",
                                                            padding: "8px 12px",
                                                            borderRadius: "8px",
                                                            border:
                                                              "1.5px solid",
                                                            borderColor:
                                                              selectedAnswers?.[
                                                                question._id
                                                              ]
                                                                ?.selectedAnswer ===
                                                              answer.optionId
                                                                ? "#00c49a"
                                                                : "#f1f5f9",
                                                            backgroundColor:
                                                              selectedAnswers?.[
                                                                question._id
                                                              ]
                                                                ?.selectedAnswer ===
                                                              answer.optionId
                                                                ? "rgba(0, 196, 154, 0.04)"
                                                                : "#fff",
                                                            transition:
                                                              "all 0.2s",
                                                            "&:hover": {
                                                              borderColor:
                                                                "#00c49a",
                                                            },
                                                            "& .MuiTypography-root":
                                                              {
                                                                width: "100%",
                                                                fontSize:
                                                                  "14px",
                                                                fontWeight: 500,
                                                                color:
                                                                  "#334155",
                                                                wordBreak:
                                                                  "break-word",
                                                                overflowWrap:
                                                                  "anywhere",
                                                                whiteSpace:
                                                                  "normal",
                                                              },
                                                            "& .sun-editor-editable":
                                                              {
                                                                backgroundColor:
                                                                  "transparent !important",
                                                                wordBreak:
                                                                  "break-word",
                                                                overflowWrap:
                                                                  "anywhere",
                                                                whiteSpace:
                                                                  "normal",
                                                              },
                                                          }}
                                                          value={
                                                            answer.optionId
                                                          }
                                                          control={
                                                            <Radio
                                                              sx={{
                                                                padding: "2px",
                                                                marginRight:
                                                                  "8px",
                                                                "&.Mui-checked":
                                                                  {
                                                                    color:
                                                                      "#00c49a",
                                                                  },
                                                              }}
                                                            />
                                                          }
                                                          label={
                                                            <div
                                                              className="sun-editor-editable"
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  answer.option,
                                                              }}
                                                            />
                                                          }
                                                        />
                                                      ),
                                                    )}
                                                  </Stack>
                                                </RadioGroup>
                                              )}
                                            </Box>
                                          </Box>
                                        </Box>
                                      </>
                                    )}
                                  </div>
                                );
                              })()}
                          </Box>
                        </Box>

                        {currentSkillQuestions[currentQuestionIndex] &&
                          (() => {
                            const question =
                              currentSkillQuestions[currentQuestionIndex];
                            return (
                              <Box
                                className="question-footer"
                                sx={{
                                  borderTop: "1px solid #eef0f7",
                                  padding: {
                                    base: "8px 12px",
                                    sm: "14px 24px",
                                  },
                                  backgroundColor: "#fff",
                                  display: "flex",
                                  flexDirection: {
                                    base: "column",
                                    xss: "row",
                                  },
                                  justifyContent: "space-between",
                                  alignItems: {
                                    base: "stretch",
                                    xss: "center",
                                  },
                                  gap: {
                                    base: "8px",
                                    xss: "10px",
                                    sm: "12px",
                                  },
                                  width: "100%",
                                  flexShrink: 0,
                                  mt: "auto",
                                }}
                              >
                                <Box
                                  sx={{
                                    flex: {
                                      base: "1 1 auto",
                                      xss: "0 1 auto",
                                    },
                                    order: { base: 1, xss: 1 },
                                    width: { base: "100%", xss: "auto" },
                                  }}
                                >
                                  <Button
                                    variant="outlined"
                                    startIcon={<ChevronLeft />}
                                    onClick={() =>
                                      handleNavigationAttempt(
                                        handlePrevQuestion,
                                      )
                                    }
                                    sx={{
                                      width: "100%",
                                      minWidth: {
                                        base: "auto",
                                        xss: "80px",
                                        sm: "120px",
                                      },
                                      borderColor: "#cbd5e0",
                                      color: "#4a5568",
                                      height: { base: "34px", sm: "36px" },
                                      textTransform: "none",
                                      padding: {
                                        base: "6px 12px",
                                        xss: "8px 16px",
                                        sm: "10px 24px",
                                      },
                                      fontSize: {
                                        base: "13px",
                                        xss: "14px",
                                        sm: "15px",
                                      },
                                      fontWeight: 600,
                                      borderRadius: "8px",
                                      "&:hover": {
                                        borderColor: "#a0aec0",
                                        backgroundColor: "#f7fafc",
                                      },
                                    }}
                                  >
                                    Back
                                  </Button>
                                </Box>

                                <Box
                                  sx={{
                                    flex: {
                                      base: "1 1 auto",
                                      xss: "0 1 auto",
                                    },
                                    order: { base: 2, xss: 2 },
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: {
                                      base: "6px",
                                      xss: "8px",
                                      sm: "12px",
                                    },
                                    justifyContent: {
                                      base: "stretch",
                                      xss: "flex-end",
                                    },
                                    width: { base: "100%", xss: "auto" },
                                  }}
                                >
                                  <Button
                                    onClick={(event) =>
                                      handleAnswerSelection(
                                        question._id,
                                        selectedAnswers?.[question._id]
                                          ?.selectedAnswer ?? null,
                                        selectedAnswers?.[question._id]
                                          ?.isAnswered ?? false,
                                        !selectedAnswers?.[question._id]
                                          ?.isReviewed,
                                      )
                                    }
                                    variant="outlined"
                                    className="mark-review-btn"
                                    sx={{
                                      textTransform: "none",
                                      fontSize: {
                                        base: "12px",
                                        xss: "13px",
                                        sm: "14px",
                                      },
                                      fontWeight: 600,
                                      padding: {
                                        base: "6px 10px",
                                        xss: "7px 14px",
                                        sm: "8px 20px",
                                      },
                                      height: { base: "34px", sm: "36px" },
                                      borderRadius: "8px",
                                      whiteSpace: "nowrap",
                                      width: { base: "100%", xss: "auto" },
                                      color: "#ff9800",
                                      borderColor: "#ff9800",
                                      backgroundColor: selectedAnswers?.[
                                        question._id
                                      ]?.isReviewed
                                        ? "rgba(255, 152, 0, 0.08)"
                                        : "transparent",
                                      borderWidth: "1.5px",
                                      "&:hover": {
                                        borderColor: "#f57c00",
                                        backgroundColor:
                                          "rgba(255, 152, 0, 0.04)",
                                      },
                                    }}
                                  >
                                    {selectedAnswers &&
                                    selectedAnswers[question._id] &&
                                    selectedAnswers[question._id].isReviewed
                                      ? "Remove review"
                                      : "Mark for review"}
                                  </Button>
                                  <Button
                                    variant="contained"
                                    endIcon={<ChevronRight />}
                                    onClick={() =>
                                      handleNavigationAttempt(
                                        handleNextQuestion,
                                      )
                                    }
                                    sx={{
                                      width: { base: "100%", xss: "auto" },
                                      minWidth: {
                                        base: "auto",
                                        xss: "90px",
                                        sm: "120px",
                                      },
                                      backgroundColor: "#00c49a",
                                      color: "#fff",
                                      height: { base: "34px", sm: "36px" },
                                      textTransform: "none",
                                      padding: {
                                        base: "6px 12px",
                                        xss: "8px 16px",
                                        sm: "10px 24px",
                                      },
                                      fontSize: {
                                        base: "13px",
                                        xss: "14px",
                                        sm: "15px",
                                      },
                                      fontWeight: 700,
                                      borderRadius: "8px",
                                      boxShadow:
                                        "0 4px 12px rgba(0, 196, 154, 0.2)",
                                      "&:hover": {
                                        backgroundColor: "#00b38c",
                                        boxShadow:
                                          "0 6px 16px rgba(0, 196, 154, 0.3)",
                                      },
                                    }}
                                  >
                                    Next
                                  </Button>
                                </Box>
                              </Box>
                            );
                          })()}
                      </Box>
                    </div>
                  </div>
                )}
              </TabPanel>
            </TabContext>
          </Box>
        </div>
      </div>
      <div
        className="modal fade overview-question-list"
        id="QuestinHelp"
        tabIndex="-1"
        aria-labelledby="QuestinHelp"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <div className="modal-body">
              {testData && testData?.length > 0 && testData[value - 2] && (
                <div>
                  {questionTypes.map((questionType, index) => {
                    if (questionType in testData[value - 2]) {
                      return difficulties?.map((difficulty) =>
                        testData[value - 2][questionType][
                          `${difficulty}Questions`
                        ]?.map((question, index) => {
                          const questionIndexNew = overallQuestionIndexNew++;
                          return (
                            <React.Fragment key={questionIndexNew}>
                              <p>{`Q${questionIndexNew + 1}. ${
                                question.question
                              }?`}</p>
                            </React.Fragment>
                          );
                        }),
                      );
                    }
                    return null;
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <SubmissionReminderModal
        open={showSubmissionReminder}
        onClose={() => {
          setShowSubmissionReminder(false);
          // Small delay to ensure modal close animations and focus traps are handled
          setTimeout(() => {
            if (pendingNavigationActionRef.current) {
              pendingNavigationActionRef.current();
              pendingNavigationActionRef.current = null;
            }
          }, 100);
        }}
        onSubmit={() => {
          if (programmingQuestionRef.current?.handleSubmit) {
            programmingQuestionRef.current.handleSubmit();
          }
          // Also proceed with navigation after submission initiated
          setTimeout(() => {
            if (pendingNavigationActionRef.current) {
              pendingNavigationActionRef.current();
              pendingNavigationActionRef.current = null;
            }
          }, 500); // Slightly longer delay for submission processing
        }}
      />
    </>
  );
}

export default Overview;
